import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export const clientServicesPhoneNumberLinkUrl = 'tel:8669504644';

const ClientServicesPhone4644 = () => {
  return (
    <WidowBlock>
      &#40;866&#41; 950&#45;4644
    </WidowBlock>
  );
};

export default ClientServicesPhone4644;
